var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('div',{staticClass:"result-panel"},_vm._l((_vm.filteredHistory),function(data,i){return _c('div',{key:i,attrs:{"value":data}},[(data.result != null)?_c('span',{class:[
          "c",
          data.result.winner.length != 1
            ? ("" + (data.result.winner[2]))
            : "ZERO" ]},[_vm._v(_vm._s(data.result.number))]):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }